import { render, staticRenderFns } from "./ProvisioningIdentidy.vue?vue&type=template&id=5f2bb0ee&scoped=true"
import script from "./ProvisioningIdentidy.vue?vue&type=script&lang=js"
export * from "./ProvisioningIdentidy.vue?vue&type=script&lang=js"
import style0 from "./ProvisioningIdentidy.vue?vue&type=style&index=0&id=5f2bb0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bb0ee",
  null
  
)

export default component.exports